import React from "react";
import {useTranslation} from "gatsby-plugin-react-i18next";
import ProofBar from "../../components/shared/proof-bar";

const LOGOS = [
    {src: "/logos/customers/olimp_logo2.webp", alt: "Olimp Labs", href: "https://olimpstore.pl/"},
    {src: "/logos/customers/BitSpreaderLogoBlack.webp", alt: "BitSpreader"},
    {src: "/logos/customers/domfort-customer-logo.webp", alt: "DOMFORTE", href: "https://www.domforte.pl"},
    {src: "/logos/customers/olimp_logo1.webp", alt: "Olimp Labs Medical Nutrition", href: "https://olimpmed24.com/"},
    {src: "/logos/customers/artmie.webp", alt: "ARTMiE", href: "https://www.artmie.de"},
    {src: "/logos/customers/bmhlogo.webp", alt: "Black Mountain Honey", href: "https://www.blackmountainhoney.co.uk/"},
    {src: "/logos/hotel/ustroniepark.svg", alt: "Ustronie Park", href: "https://www.ustroniepark.pl/"},
    {src: "/logos/hotel/domkiwnaturze.svg", alt: "Domki w Naturze", href: "https://www.domkiwnaturze.pl/"},
    {src: "/logos/hotel/zinarcastle.svg", alt: "Zinar Castle", href: "https://www.zinarcastle.pl/"},
    {src: "/logos/hotel/dworwtomaszowicach.svg", alt: "Dwór w Tomaszowicach", href: "https://www.dwor.pl/"},
    {src: "/logos/hotel/foresthotel.svg", alt: "Forest Hotel", href: "https://www.foresthotel.pl/"},
    {src: "/logos/hotel/artusresort.png", alt: "Artus Resort", href: "https://www.artusresort.pl/"},
    {src: "/logos/hotel/goosehouse.png", alt: "Goose House", href: "https://www.goosehaus.pl/"},
    {src: "/logos/hotel/domekprzyplazy.png", alt: "Domki Przy Plaży"},
];

const CustomerLogos = () => {
    const {t} = useTranslation();
    const metrics = [
        {value: "80%", label: t("of enquiries handled automatically"), client: "Black Mountain Honey", to: "/usecase/bmh/"},
        {value: "-70%", label: t("fewer enquiries passed to the support team"), client: "Olimp Labs", to: "/usecase/olimplabs/"},
        {value: "-60%", label: t("fewer escalations to the front desk"), client: "Umili Resorts", to: "/usecase/umili/"},
    ];
    return <ProofBar metrics={metrics} logos={LOGOS} label={t("Used by 500+ businesses every month")}/>;
};

export default CustomerLogos;
